import { FC } from "react";
import { ErrorBoundary } from "@sentry/nextjs";
import { TransformedProductEntity } from "../../../types/transformed_product_entity";
import { ProductCard, ProductCarousel } from "../../organisms";
import { Typography } from "@mui/material";
import { Stack } from "@mui/system";

interface Props {
  products: TransformedProductEntity[];
}

export const MoreLikeThis: FC<Props> = ({ products }) => {
  return (
    <Stack gap={{ xs: 1, lg: 2 }}>
      <div>
        <Typography variant="subtitle1" fontWeight={700}>
          more like this
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Similar products
        </Typography>
      </div>
      <ProductCarousel products={products} />
    </Stack>
  );
};
